<div class="table-container">
  <div class="table">
    <div class="table-heading">
      <div class="table-item" *ngFor="let reportFieldName of reportFields">
        {{ 'reports.' + reportFieldName | translate }}
      </div>
      <div class="table-item"></div>
    </div>
    <div *ngFor="let reportRow of flatReport">
      <div class="table-row">
        <div class="table-item" *ngFor="let reportField of reportFields">
          {{ reportRow[reportField] }}
        </div>
        <div class="table-item">
          <gl-button
            icon
            icon-center="glicon-event-list"
            (onClick)="details.toggleState()"
            class="right"
            title="{{ 'actions.showInfo' | translate }}"
          ></gl-button>
        </div>
      </div>
      <lms-list-row-detail #details>
        <div *ngIf="getReportRowChild(reportRow['licenseId'])">
          <table class="responsive-table table-layout-fixed word-wrap">
            <thead>
              <tr>
                <th *ngFor="let childReportField of reportFields">{{ childReportField }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let chidlReportRow of getReportRowChild(reportRow['licenseId'])">
                <td *ngFor="let childReportField of reportFields">{{ chidlReportRow[childReportField] }}</td>
              </tr>
            </tbody>
          </table>
          <div class="row">
            <div class="col s12">
              <gl-button
                color-secondary
                icon-left="glicon-download"
                class="right"
                [text]="'nouns.download' | translate"
                (onClick)="downloadCSV(filterReport(getReportRowChild(reportRow['licenseId'])))"
              >
              </gl-button>
            </div>
          </div>
        </div>
      </lms-list-row-detail>
    </div>
  </div>
</div>
